import {
	Alert,
	AlertDescription,
	Button,
	Card,
	CardContent,
	CardHeader,
	CardTitle,
	Skeleton,
} from "@monbits/ui";
import { AlertCircle, Send } from "lucide-react";
import * as React from "react";
import notificationQueries from "src/queries/notification-queries";
import TelegramConnectForm from "./telegram-connect-form";
import TelegramConnectedView from "./telegram-connected-view";

const TelegramNotificationSection: React.FC = () => {
	const listNotifications = notificationQueries.listNotifications();
	const [forceReconfigure, setForceReconfigure] = React.useState(false);

	const existing = React.useMemo(
		() => listNotifications.data?.find((n) => n.channel === "telegram"),
		[listNotifications.data],
	);

	if (listNotifications.isLoading) {
		return (
			<Card>
				<CardHeader>
					<Skeleton className="h-6 w-32" />
					<Skeleton className="h-4 w-64 mt-2" />
				</CardHeader>
				<CardContent className="space-y-4">
					<Skeleton className="h-24 w-full" />
					<Skeleton className="h-32 w-full" />
				</CardContent>
			</Card>
		);
	}

	if (listNotifications.isError) {
		return (
			<Card>
				<CardHeader>
					<CardTitle className="flex items-center gap-2">
						<Send className="h-5 w-5 text-muted-foreground" aria-hidden />
						Telegram
					</CardTitle>
				</CardHeader>
				<CardContent>
					<Alert variant="destructive">
						<AlertCircle className="h-4 w-4" />
						<AlertDescription className="flex items-center justify-between gap-4">
							<span>Unable to load notification settings.</span>
							<Button
								variant="outline"
								size="sm"
								onClick={() => listNotifications.refetch()}
							>
								Retry
							</Button>
						</AlertDescription>
					</Alert>
				</CardContent>
			</Card>
		);
	}

	if (!existing || forceReconfigure) {
		return (
			<TelegramConnectForm onConnected={() => setForceReconfigure(false)} />
		);
	}

	return (
		<TelegramConnectedView
			notification={existing}
			onReconfigure={() => setForceReconfigure(true)}
			onDisconnected={() => setForceReconfigure(false)}
		/>
	);
};

export default TelegramNotificationSection;
